import $ from 'jquery'
import jQueryBridget from 'jquery-bridget'
import imagesloaded from 'imagesloaded'
import Masonry from 'masonry-layout'

import angular from 'angular'
import 'angular-i18n/angular-locale_en.js'
import 'angular-i18n/angular-locale_fr.js'
import angularUiRouter from 'angular-ui-router'
import angularMasonry from 'angular-masonry'
import angularCookies from 'angular-cookies'
import angularUiBootstrap from 'angular-ui-bootstrap'
import angularMoment from 'angular-moment'
import uiSelect from 'ui-select'
import angularResource from 'angular-resource'
import angularPermission from 'angular-permission'
import angularBootstrapAffix from 'angular-bootstrap-affix'
import angularUiMask from 'angular-ui-mask'
import angularAnimate from 'angular-animate'
import ngFocusIf from 'ng-focus-if'
import angularNvd3 from 'angular-nvd3'
import angularRecaptcha from 'angular-recaptcha'
import angularSanitize from 'angular-sanitize'
import angularClipboard from 'angular-clipboard'
import 'ngSmoothScroll' // 'smoothScroll'
import 'angular-file-upload' // angularFileUpload
import 'angular-easyfb' // ezfb

import navigationLoggerRun from './config/navigation-logger'
import constants from './config/constants'
import featuresRun from './config/features'
import momentRun from './config/moment'
import tagManagerRun from './config/tagmanager'
import analyticsRun from './config/analytics'
import rolesRun from './config/roles'
import routesConfigInitial from './config/routes'
import statesRun from './config/states'
import uiMaskRun from './config/ui-mask'
import numeralConfig from './config/numeral'
import avatar from './directives/avatar/directive'
import chartInfo from './directives/chart-info/chartInfo'
import chartMonth from './directives/chart-month/directive'
import chartPotImage from './directives/chart-pot-image/directive'
import circleRating from './directives/circle-rating/directive'
import clampDirective from './directives/clamp/clamp'
import cookiesBar from './directives/cookies-bar/directive'
import emailForm from './directives/email-form/email-form'
import dateField from './directives/date-field/date-field'
import forceUppercase from './directives/forceUppercase/forceUppercase'
import hint from './directives/hint/directive'
import navbarWhiteBackground from './directives/landing/navbarBackground'
import navbarOpacity from './directives/landing/navbarOpacity'
import landscapeCanvas from './directives/landscape-canvas/directive'
import landscapeForm from './directives/landscape-form/directive'
import newsletterModal from './directives/newsletterModal/newsletterModal'
import noApplyClick from './directives/no-apply-click/directive'
import plumFeature from './directives/plum-feature/directive'
import popin from './directives/popin/popin.directive'
import potBalance from './directives/pot-balance/directive'
import potDivision from './directives/pot-division/directive'
import report from './directives/report/report'
import scrollToNext from './directives/scrollToNext/scrollToNext'
import subscriptionTimelineGraph from './directives/subscriptionTimelineGraph/subscriptionTimelineGraph'
import updateTitle from './directives/updateTitle/updateTitle'
import birthdate from './directives/validators/birthdate/directive'
import compareTo from './directives/validators/compareTo/compareTo'
import ReportManager from './models/reports'
import resources from './models/resources'
import AdwordsService from './services/adwords/adwords'
import AlertManager from './services/alerts/alerts'
import ApiService from './services/api/api'
import LogoutService from './services/api/logout'
import BubblesService from './services/bubbles/service'
import userCommunityService from './services/community/userCommunity'
import Chart from './services/conso/chart'
import ContractService from './services/contract/contract'
import CookiesService from './services/cookies/service'
import DeviceChecker from './services/deviceChecker/device.checker'
import ErrorCatcher from './services/errorcatcher/errorcatcher'
import featureService from './services/features/featuresService'
import capitalize from './services/filters/capitalize'
import ceil from './services/filters/ceil'
import clientId from './services/filters/clientId'
import contractStatus from './services/filters/contractStatus'
import elision from './services/filters/elision'
import frAmount from './services/filters/frAmount'
import iban from './services/filters/iban'
import phone from './services/filters/phone'
import prm from './services/filters/prm'
import integer from './services/filters/integer'
import decimals from './services/filters/decimals'
import gaEventsService from './services/gaEvents/gaEventsService'
import LandscapeElements from './services/landscape/landscapeElements'
import MobilePhone from './services/mobilePhone/mobilePhone'
import PotManager from './services/pot/service'
import PrmUtilsService from './services/prmUtils/prmUtils'
import rawHtml from './services/rawHtml/filter'
import ReferencesService from './services/references/references'
import campaignLandingCtrl from './states/campaignLanding/campaignLanding'
import campaignLandingTemplate from './states/campaignLanding/campaignLandingTemplate'
import communityCtrl from './states/community/community'
import termsCtrl from './states/terms/terms'
import confirmCtrl from './states/confirm/confirm'
import confirmChangeMailCtrl from './states/confirmChangeMail/confirmChangeMail'
import contactModalCtrl from './states/contactModal/contactModal'
import flowCtrl from './states/flow/flow'
import unergieFooter from './states/footer/unergieFooter'
import forgotPasswordCtrl from './states/forgotPassword/forgotPassword'
import hintsCtrl from './states/hints/hints'
import homeCtrl from './states/home/home'
import animatedOnVisible from './states/landing/animatedOnVisible'
import landingCtrl from './states/landing/landing'
import scrollSendEvent from './states/landing/sendEvent'
import linkyModalCtrl from './states/linkyModal/controller'
import loginCtrl from './states/login/login'
import landscapeCtrl from './states/landscape/landscape'
import logoutCtrl from './states/logout/controller'
import myMeterCtrl from './states/myMeter/controller'
import navbarAccountCtrl from './states/navbarAccount/navbarAccount'
import offerCtrl from './states/offer/controller'
import promoCtrl from './states/promo/promo'
import proofOfResModalCtrl from './states/proofOfResModal/proofofresmodal'
import selfReportCtrl from './states/selfReport/selfReport'
import selfReportImgValue from './states/selfReport/selfReportImgValue'
import selfReportStep from './states/selfReport/selfReportStep'
import selfReportStepImage from './states/selfReport/selfReportStepImage'
import signupCtrl from './states/signup/signup'
import sponsorCtrl from './states/sponsor/sponsor'
import subscriptionEndCtrl from './states/subscriptionEnd/subscriptionEnd'
import subscriptionSummaryCtrl from './states/subscriptionSummary/subscriptionSummary'
import anonPaymentSummaryCtrl from './states/anonPaymentSummary/anonPaymentSummary'
import anonTerminationSummaryCtrl from './states/anonTerminationSummary/anonTerminationSummary'

import unergieAccount from './states/account/account.module'
import unergieEndSubscription from './states/endSubscription/endSubscription.module'
import unergieInvoice from './states/invoice/invoice.module'
import unergieMandateConfirmation from './states/mandateConfirmation/mandateConfirmation.module'
import unergieModal from './states/modal/modal.module'
import unergieNavbar from './states/navbar/navbar.module'
import unergiePaymentConfirmation from './states/paymentConfirmation/paymentConfirmation.module'
import unergieVendorSignatureConfirmation from './states/vendorSignatureConfirmation/vendorSignatureConfirmation.module'
import unergiePersonalInformation from './states/personalInformation/personalInformation.module'
import unergieQuotation from './states/quotation/quotation.module'
import unergieSecurityDepositSummary from './states/securityDepositSummary/securityDepositSummary.module'
import unergieSubscription from './states/subscription/subscription.module'
import unergieSubscriptionLanding from './states/subscriptionLanding/subscriptionLanding.module'
import unergieTracking from './states/tracking/tracking.module'
import unergieTemplateInfo from './states/template/template.module'

// Required for angular-masonry
jQueryBridget('imagesloaded', imagesloaded, $)
jQueryBridget('masonry', Masonry, $)

/* Angular styleguide to use https://github.com/toddmotto/angular-styleguide */
export default angular
.module('unergie.main', [
    /* Common angular module */
    angularUiRouter,
    angularMasonry,
    angularCookies,
    angularUiBootstrap,
    angularMoment,
    uiSelect,
    angularResource,
    angularPermission.permission,
    angularPermission.uiPermission,
    angularBootstrapAffix,
    angularUiMask,
    angularAnimate,
    ngFocusIf,
    angularNvd3,
    angularRecaptcha,
    angularSanitize,
    angularClipboard.name,
    'smoothScroll',
    'angularFileUpload',
    'ezfb',

    /* Unergie component module */
    unergieAccount,
    unergieEndSubscription,
    unergieInvoice,
    unergieMandateConfirmation,
    unergieModal,
    unergieNavbar,
    unergiePaymentConfirmation,
    unergieVendorSignatureConfirmation,
    unergiePersonalInformation,
    unergieQuotation,
    unergieSecurityDepositSummary,
    unergieSubscription,
    unergieSubscriptionLanding,
    unergieTracking,
    unergieTemplateInfo,
])
.constant('RoomName', constants.RoomName)
.constant('ImplementationToText', constants.ImplementationToText)
.constant('MetterKind', constants.MetterKind)
.constant('MailAdresses', constants.MailAdresses)
.constant('RecaptchaKey', constants.RecaptchaKey)
.constant('ContactTelephone', constants.ContactTelephone)
.constant('ContactSubjects', constants.ContactSubjects)
.constant('ContractStatus', constants.ContractStatus)
.constant('UserStatus', constants.UserStatus)
.constant('ContractStatusLabel', constants.ContractStatusLabel)
.constant('PaymentStatus', constants.PaymentStatus)
.constant('PaymentModes', constants.PaymentModes)
.constant('CampaignLandingType', constants.CampaignLandingType)
.constant('CommonRegex', constants.CommonRegex)
.constant('StaticTariff', constants.StaticTariff)
.constant('LandingPageLink', constants.landingPageLink)
.factory('Contract', resources.Contract)
.factory('ContractDraft', resources.ContractDraft)
.factory('User', resources.User)
.factory('Hint', resources.Hint)
.factory('Community', resources.Community)
.factory('BillingAddress', resources.BillingAddress)
.factory('Features', resources.Features)
.factory('LandscapeQuestions', resources.LandscapeQuestions)
.factory('ProviderInfo', resources.ProviderInfo)
.factory('DataAccessReferences', resources.DataAccessReferences)
.factory('DataAccessVariables', resources.DataAccessVariables)
.factory('CampaignLanding', resources.CampaignLanding)
.factory('RefGoals', resources.RefGoals)
.factory('Contact', resources.Contact)
.factory('LogNavigation', resources.LogNavigation)
.factory('NavError', resources.NavError)
.factory('TariffResource', resources.TariffResource)
.factory('SelfReport', resources.SelfReport)
.factory('BillingAcc', resources.BillingAcc)
.factory('Invoice', resources.Invoice)
.factory('AnonPayment', resources.AnonPayment)
.factory('AnonTermination', resources.AnonTermination)
.factory('SecurityDeposit', resources.SecurityDeposit)
.factory('ErrorCatcher', ErrorCatcher)
.factory('ApiService', ApiService)
.factory('featuresService', featureService)
.factory('ReportManager', ReportManager)
.factory('AdwordsService', AdwordsService)
.factory('AlertManager', AlertManager)
.factory('LogoutService', LogoutService)
.factory('BubblesService', BubblesService)
.factory('userCommunityService', userCommunityService)
.factory('Chart', Chart)
.factory('Tokens', resources.Tokens)
.config(routesConfigInitial)
.config(/** @ngInject */(ezfbProvider) => {
    // Set up FB
    ezfbProvider.setLocale('fr_FR')
    ezfbProvider.setInitParams({
        appId: '119786712027642',
        version: 'v2.10',
    })
})
.run(tagManagerRun)
.run(analyticsRun)
.run(featuresRun)
.run(momentRun)
.run(navigationLoggerRun)
.run(rolesRun)
.run(statesRun)
.run(uiMaskRun)
.run(numeralConfig)
.controller('homeCtrl', homeCtrl)
.controller('landingCtrl', landingCtrl)
.directive('avatar', avatar)
.directive('chartInfo', chartInfo)
.directive('chartMonth', chartMonth)
.directive('chartPotImage', chartPotImage)
.directive('circleRating', circleRating)
.directive('clamp', clampDirective)
.directive('cookiesBar', cookiesBar)
.directive('emailForm', emailForm)
.directive('dateField', dateField)
.directive('forceUppercase', forceUppercase)
.directive('hint', hint)
.directive('navbarWhiteBackground', navbarWhiteBackground)
.directive('navbarOpacity', navbarOpacity)
.directive('landscapeCanvas', landscapeCanvas)
.directive('landscapeForm', landscapeForm)
.directive('newsletterModal', newsletterModal)
.directive('noApplyClick', noApplyClick)
.directive('plumFeature', plumFeature)
.directive('popin', popin)
.directive('potBalance', potBalance)
.directive('potDivision', potDivision)
.directive('report', report)
.directive('scrollToNext', scrollToNext)
.directive('subscriptionTimelineGraph', subscriptionTimelineGraph)
.directive('updateTitle', updateTitle)
.directive('birthdate', birthdate)
.directive('compareTo', compareTo)
.factory('ContractService', ContractService)
.factory('CookiesService', CookiesService)
.factory('DeviceChecker', DeviceChecker)
.filter('capitalize', capitalize)
.filter('ceil', ceil)
.filter('clientId', clientId)
.filter('contractStatus', contractStatus)
.filter('elision', elision)
.filter('frAmount', frAmount)
.filter('iban', iban)
.filter('phone', phone)
.filter('prm', prm)
.filter('integer', integer)
.filter('decimals', decimals)
.factory('gaEventsService', gaEventsService)
.factory('LandscapeElements', LandscapeElements)
.factory('MobilePhone', MobilePhone)
.factory('PotManager', PotManager)
.factory('PrmUtilsService', PrmUtilsService)
.filter('rawHtml', rawHtml)
.factory('ReferencesService', ReferencesService)
.controller('campaignLandingCtrl', campaignLandingCtrl)
.directive('campaignLandingTemplate', campaignLandingTemplate)
.controller('communityCtrl', communityCtrl)
.controller('termsCtrl', termsCtrl)
.controller('confirmCtrl', confirmCtrl)
.controller('confirmChangeMailCtrl', confirmChangeMailCtrl)
.controller('contactModalCtrl', contactModalCtrl)
.controller('flowCtrl', flowCtrl)
.directive('unergieFooter', unergieFooter)
.controller('forgotPasswordCtrl', forgotPasswordCtrl)
.controller('hintsCtrl', hintsCtrl)
.directive('animatedOnVisible', animatedOnVisible)
.directive('scrollSendEvent', scrollSendEvent)
.controller('linkyModalCtrl', linkyModalCtrl)
.controller('loginCtrl', loginCtrl)
.controller('landscapeCtrl', landscapeCtrl)
.controller('logoutCtrl', logoutCtrl)
.controller('myMeterCtrl', myMeterCtrl)
.controller('navbarAccountCtrl', navbarAccountCtrl)
.controller('offerCtrl', offerCtrl)
.controller('promoCtrl', promoCtrl)
.controller('proofOfResModalCtrl', proofOfResModalCtrl)
.controller('selfReportCtrl', selfReportCtrl)
.directive('selfReportImgValue', selfReportImgValue)
.directive('selfReportStep', selfReportStep)
.directive('selfReportStepImage', selfReportStepImage)
.controller('signupCtrl', signupCtrl)
.controller('sponsorCtrl', sponsorCtrl)
.controller('subscriptionSummaryCtrl', subscriptionSummaryCtrl)
.controller('subscriptionEndCtrl', subscriptionEndCtrl)
.controller('anonPaymentSummaryCtrl', anonPaymentSummaryCtrl)
.controller('anonTerminationSummaryCtrl', anonTerminationSummaryCtrl)
.name



// WEBPACK FOOTER //
// ./src/main.module.js